module.exports = __webpack_public_path__ + "img/image_part_007.9a7306c6.jpg";